<template>
  <div class="wholesale-statistics-page p-4 flex flex-col md:flex-row gap-4">
    <div
      style="min-width: 384px"
      class="date-filters flex flex-col gap-2 shrink-0"
    >
      <h1>Estadísticas de Ventas Mayoristas</h1>
      <label for="fromDate">Desde:</label>
      <input type="date" v-model="fromDate" id="fromDate" />
      <label for="toDate">Hasta:</label>
      <input type="date" v-model="toDate" id="toDate" />
      <button @click="fetchStatistics" class="btn-dark-button w-100">
        Consultar estadísticas
      </button>

      <hr />
      <p>Filtrar por mes</p>
      <div>
        <select v-model="selectedMonth">
          <option v-for="month in months" :key="month" :value="month">
            {{ month }}
          </option>
        </select>
        <select v-model="selectedYear">
          <option v-for="year in years" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
        <button class="btn-dark-button w-full mt-2" @click="fetchByMonth">
          Filtrar por mes
        </button>
      </div>
    </div>
    <div v-if="loading" class="loading-indicator">
      <p>Cargando estadísticas...</p>
      <baseSmallSpinner v-if="loading"></baseSmallSpinner>
    </div>
    <div class="statistics-results" v-else-if="statistics">
      <h2>Resultados de la consulta</h2>
      <p><b>Desde:</b> {{ fromDate }}</p>
      <p><b>Hasta:</b> {{ toDate }}</p>

      <hr />
      <h3>Resumen de usuarios</h3>
      <ul>
        <li>
          <b>Usuarios que iniciaron sesión:</b>
          {{ statistics.basicUserStats.usuariosIniciaronSesion }}
        </li>
        <li>
          <b>Usuarios activos:</b>
          {{ statistics.basicUserStats.usuariosActivos }}
        </li>
        <li>
          <b>Usuarios que gestionaron el carrito:</b>
          {{ statistics.basicUserStats.usuariosGestionaronCarritoDeCompra }}
        </li>
        <li>
          <b>Usuarios que crearon órdenes:</b>
          {{ statistics.basicUserStats.usuariosCrearonOrdenes }}
        </li>
        <li>
          <b>Total de órdenes creadas:</b>
          {{ statistics.basicUserStats.totalOrdenesCreadas }}
        </li>
        <li>
          <b>Usuario más activo:</b>
          {{ statistics.basicUserStats.usuarioMasActivo }}
        </li>
      </ul>

      <h3 class="mt-8">Usuarios activos sin órdenes</h3>
      <button
        @click="
          expandSection === 'activeUsersNoOrders'
            ? (expandSection = '')
            : (expandSection = 'activeUsersNoOrders')
        "
        class="btn-clear-button"
      >
        {{ expandSection === "activeUsersNoOrders" ? "Ocultar" : "Mostrar" }}
      </button>
      <table
        class="default-table w-full"
        v-if="expandSection === 'activeUsersNoOrders'"
      >
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Apellido</th>
            <th>Correo electrónico</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in statistics.activeUsersNoOrders" :key="user.id">
            <td>{{ user.name }}</td>
            <td>{{ user.surname }}</td>
            <td>{{ user.email }}</td>
          </tr>
        </tbody>
      </table>

      <h3 class="mt-8">Usuarios con eventos de inicio de sesión</h3>
      <button
        @click="
          expandSection === 'loginEvents'
            ? (expandSection = '')
            : (expandSection = 'loginEvents')
        "
        class=" btn-clear-button"
      >
        {{ expandSection === "loginEvents" ? "Ocultar" : "Mostrar" }}
      </button>
      <table
        class="default-table w-full"
        v-if="expandSection === 'loginEvents'"
      >
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Correo electrónico</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in statistics.usersWithLoginEvents" :key="user.id">
            <td>{{ user.fullName }}</td>
            <td>{{ user.email }}</td>
          </tr>
        </tbody>
      </table>

      <h3 class="mt-8">Usuarios con empresa que no realizaron órdenes</h3>
      <button
        @click="
          expandSection === 'noOrdersWithCompany'
            ? (expandSection = '')
            : (expandSection = 'noOrdersWithCompany')
        "
        class="btn-clear-button"
      >
        {{ expandSection === "noOrdersWithCompany" ? "Ocultar" : "Mostrar" }}
      </button>
      <table
        class="default-table w-full"
        v-if="expandSection === 'noOrdersWithCompany'"
      >
        <thead>
          <tr>
            <th>Name</th>
            <th>Compañía</th>
            <th>Correo electrónico</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="user in statistics.activeUsersNoOrdersWithCompany"
            :key="user.id"
          >
            <td>{{ user.fullName }}</td>
            <td>{{ user.companyName }}</td>
            <td>{{ user.email }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { getWholeStatistics } from "@/api/store/Statistics.js";
export default {
  name: "WholesaleStatisticsPage",
  data() {
    return {
      fromDate: null,
      toDate: null,
      statistics: null,
      selectedMonth: null,
      expandSection: "",
      selectedYear: new Date().getFullYear(),
      months: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
      years: Array.from(
        { length: 3 },
        (_, i) => new Date().getFullYear() - i
      ).reverse(),
      loading: false
    };
  },
  mounted() {
    const currentMonth =
      new Date().getMonth() > 1 ? new Date().getMonth() - 1 : 11;
    this.selectedMonth = this.months[currentMonth];
  },
  methods: {
    async fetchStatistics() {
      this.loading = true;
      try {
        this.statistics = await getWholeStatistics(this.fromDate, this.toDate);
      } catch (error) {
        console.error("Error fetching statistics:", error);
        this.statistics = null;
      } finally {
        this.loading = false;
      }
    },
    fetchByMonth() {
      const monthIndex = this.months.indexOf(this.selectedMonth) + 1; // Months are 1-indexed
      const year = this.selectedYear;
      const fromDate = `${year}-${String(monthIndex).padStart(2, "0")}-01`;
      const toDate = `${year}-${String(monthIndex).padStart(2, "0")}-${new Date(
        year,
        monthIndex,
        0
      ).getDate()}`;

      this.fromDate = fromDate;
      this.toDate = toDate;

      this.fetchStatistics();
    }
  }
};
</script>
